























import { getOrderDataTree } from '@/api/content'
import { defineComponent, ref } from '@vue/composition-api'
import DataTree from './DataTree.vue'

export default defineComponent({
  name: 'OrderDetailTree',
  components: {
    DataTree
  },
  setup(props, context) {
    const api = `${process.env.VUE_APP_BASE_API}api/v1/`
    const route = context.root.$route
    const orderId = route.params.id
    const productGroup = route.params.productGroup

    const tree = ref<any>([])
    const loadingTree = ref(true)
    const loadingContentSpinner = ref(false)
    const selectedContent = ref(false)
    const iframeSrc = ref<string | null>(null)

    const completedIframe = () => {
      loadingContentSpinner.value = false
      selectedContent.value = true
    }

    const handleClick = (element) => {
      selectedContent.value = false
      loadingContentSpinner.value = true
      iframeSrc.value = `${api}${element.editorPageUrl}`
    }

    const request = getOrderDataTree(orderId, productGroup)
    request.then((response) => {
      tree.value = response.data
      loadingTree.value = false
    })

    return {
      tree,
      loadingTree,
      loadingContentSpinner,
      selectedContent,
      iframeSrc,
      handleClick,
      completedIframe
    }
  }
})
